import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    currentProject: { account: { billingTerms: {}, accountManager: {}, _id: null }, budget: {}, time: { total: {} } },
}

const projectSlice = createSlice({
    name: "project",
    initialState: initialState,
    reducers: {
        clearProject(state) {
            state.currentProject = initialState.currentProject;
        },
        getProject() { },
        setCurrentProject(state, action) {
            state.currentProject = action.payload;
        },
        updateProject() { },
        setProjectExternalBoard() { },
        updateProjectState(state, action) {
            if (state.currentProject) {
                state.currentProject = { ...state.currentProject, ...action.payload.project };
            }
        },

        getProjects() { },

        setProjectResponsible() { },
        updateProjectResponsible(state, action) {
            if (state.currentProject) {
                state.currentProject.responsible = action.payload.responsible;
            }
        },

        setProjectAssignees() { },
        updateProjectAssignees(state, action) {
            if (state.currentProject) {
                state.currentProject.responsible = action.payload.responsible;
                state.currentProject.assignees = action.payload.assignees;
            }
        },

        createProject() { },

        updateProjectStatus(state, action) { },
        setProjectStatus(state, action) {
            if (state.currentProject) {
                state.currentProject.status = action.payload.project.status;
                state.currentProject = { ...state.currentProject, completedDate: action.payload.project.completedDate, status: action.payload.project.status };
            }
        },

        completeProject() { },
        setProjectCompleted(state, action) {
            if (state.currentProject) {
                state.currentProject = { ...state.currentProject, completedDate: action.payload.project.completedDate, status: 'Completed' };
            }
        },

        deleteProject(state) {
            state.currentProject = initialState.currentProject;
        },

        restoreProject() { },
    }
});

export const {
    clearProject,
    getProject,
    setCurrentProject,
    getProjects,
    updateProject,
    setProjectExternalBoard,
    updateProjectState,
    setProjectResponsible,
    updateProjectResponsible,
    setProjectAssignees,
    updateProjectAssignees,
    createProject,
    updateProjectStatus,
    setProjectStatus,
    completeProject,
    setProjectCompleted,
    deleteProject,
    restoreProject,
} = projectSlice.actions;

export default projectSlice.reducer;
